export default class extends Controller {
  static targets = [
    "blockedReason", "capacityIssueSelect", "waitingForUserSelect", 
    "waitingForContactSelect", "waitingReasonSelect", "clientWaitingReasonSelect",
    "notifyTags", "tag", "errorMessages"
  ]

  connect() {
    this.setupInitialState()
    App.Helpers.addAjaxHandlers(this.element, this.handleSuccess.bind(this), this.handleError.bind(this))
  }

  setupInitialState() {
    const selectedRadio = this.element.querySelector('input[type="radio"][name="task[blocked_reason]"]:checked')
    if (selectedRadio) {
      this.enableRelevantFields(selectedRadio.value)
    } else {
      this.disableAllFields()
    }
  }

  toggleRelevantFields(event) {
    const selectedReason = event.target.value
    this.resetAllFields()
    this.enableRelevantFields(selectedReason)
  }

  enableRelevantFields(selectedReason) {
    this.disableAllFields()

    switch(selectedReason) {
      case 'capacity_issue':
        this.enableTarget(this.capacityIssueSelectTarget)
        break
      case 'waiting_for_teammate':
        this.enableTarget(this.waitingForUserSelectTarget)
        this.enableTarget(this.waitingReasonSelectTarget)
        break
      case 'waiting_for_client':
        this.enableTarget(this.waitingForContactSelectTarget)
        this.enableTarget(this.clientWaitingReasonSelectTarget)
        break
    }
  }

  resetAllFields() {
    [this.capacityIssueSelectTarget, this.waitingForUserSelectTarget,
     this.waitingForContactSelectTarget, this.waitingReasonSelectTarget,
     this.clientWaitingReasonSelectTarget].forEach(target => {
       if (target) {
         target.value = ''
       }
     })
  }

  disableAllFields() {
    [this.capacityIssueSelectTarget, this.waitingForUserSelectTarget,
     this.waitingForContactSelectTarget, this.waitingReasonSelectTarget,
     this.clientWaitingReasonSelectTarget].forEach(target => {
       if (target) {
         this.disableTarget(target)
       }
     })
  }

  enableTarget(target) {
    if (target) {
      target.disabled = false
      target.classList.remove('disabled')
    }
  }

  disableTarget(target) {
    if (target) {
      target.disabled = true
      target.classList.add('disabled')
    }
  }

  handleSuccess(event, response) {
    const blockedStatusElement = document.querySelector('[data-blocked-status]');
    if (blockedStatusElement && response.blocked_html) {
      blockedStatusElement.innerHTML = response.blocked_html;
    }
    this.closeForm();
    const taskWasBlocked = new CustomEvent('task-block:success', { detail: { id: response.task.id } });
    document.dispatchEvent(taskWasBlocked);
  }

  closeForm(event) {
    event && event.preventDefault()
    App.SlideOut.close({ element: this.element })
  }

  handleError(event, xhr) {
    console.error('Form submission failed:', xhr.responseText)
    this.displayErrors(JSON.parse(xhr.responseText).errors)
  }

  displayErrors(errors) {
    this.errorMessagesTarget.innerHTML = ''
    errors.forEach(error => {
      const errorElement = document.createElement('div')
      errorElement.className = 'error-message'
      errorElement.innerText = error
      this.errorMessagesTarget.appendChild(errorElement)
    })
  }

  validateForm(event) {
    const selectedReason = this.element.querySelector('input[name="task[blocked_reason]"]:checked')
    if (!selectedReason) {
      event.preventDefault()
      alert('Please select a reason for blocking the task.')
      return false
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/blocked-task-form-controller.js